import {UpdateWorkshop, Workshop} from '../types/Workshop';
import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

class WorkshopsService {
  public async getAllWorkshops(): Promise<Workshop[]> {
    return handleError(
      () => httpClient.get<Workshop[]>('/workshops'),
      'Error fetching workshops:',
      () => []
    );
  }

  public async getWorkshop(id: string): Promise<Workshop> {
    return handleError(
      () => httpClient.get<Workshop>(`/workshops/${id}`),
      'Error fetching workshop:'
    );
  }

  public async createWorkshop(workshop: Omit<UpdateWorkshop, 'id'>): Promise<void> {
    const workshopWithId: UpdateWorkshop = {
      ...workshop,
      id: crypto.randomUUID()
    };
    return handleError(
      () => httpClient.post<void>('/workshops', workshopWithId),
      'Error creating workshop:'
    );
  }

  public async updateWorkshop(workshop: UpdateWorkshop): Promise<void> {
    return handleError(
      () => httpClient.put<void>(`/workshops/${workshop.id}`, workshop),
      'Error updating workshop:'
    );
  }

  public async deleteWorkshop(id: string): Promise<void> {
    return handleError(
      () => httpClient.delete<void>(`/workshops/${id}`),
      'Error deleting workshop:'
    );
  }
}

const workshopsService = new WorkshopsService();
export default workshopsService;
